import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { CanonicalService } from '../shared/seo/canonical.service';
import { SeoService } from '../shared/seo/seo.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';

declare var $
@Component({
  selector: 'app-find-dealer',
  templateUrl: './find-dealer.component.html',
  styleUrls: ['./find-dealer.component.scss']
})
export class FindDealerComponent implements OnInit {
  activeView: string = 'list';
  sub: Subscription = new Subscription();
  lobList: any;
  environment1 =environment.s3bucket.url;
  dealerLocaterForm!: FormGroup;
  stateList: any;
  districtList: any;
  maker: boolean = true;
  divisions: any = [];
  count: any;
  data: any = [];
  dataloaded: boolean = false;
  latLongList: any[] = [];
  previous: any;
  centerLat = 23.473324;
  centerLng = 77.947998;
  countryRestriction = {
    latLngBounds: {
      east: 97.4025614766,
      north: 35.4940095078,
      south: 7.96553477623,
      west: 68.1766451354,
    },
    strictBounds: true,
  };
  Lng: any;
  Lat: any;
  zoom = 4;
  showBreadCrumb: boolean = false;
  breadcrumbdata: any = [];
  countDisplay: any = 0;
  flag: boolean = false;
  clickDisable: boolean = false;
  openedWindow: any;
  division: any;
  openAgmWindow: boolean = false;
  isShowLocationSearch: boolean = false
  hideSearch = true
  isMobile: boolean = false;
  dealerCode: string;
  metatitle: any = "Find Tata Motors Dealer | Nearest Dealer Outlet Locator";
  metadesc: any="Enquire, book and buy online Tata Ace, Intra, Yodha Pickup, Winger, Magic, Signa, Prima, Ultra, and entire Truck, Tipper, Bus range with Tata Motors authorized dealers.";


  constructor(private apiService: ApiService, private formBuilder: FormBuilder,
    private localStorage: secureStorage,private canonicalservice: CanonicalService,
    private router: Router, private seoservice: SeoService,@Inject(PLATFORM_ID) private platformId: Object,

  ) { }

  ngOnInit(): void {
    this.canonicalservice.createCanonicalURL('');
    this.seo();
    if (isPlatformBrowser(this.platformId)) {
    this.dealerCode= localStorage.getItem("dealercd"); 
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){

      this.isMobile = true;
    }else{

      this.isMobile = false;
    }
    $('.header').addClass('p-scroll');
    this.dealerLocaterForm = this.formBuilder.group({
      lob: ["", Validators.required],
      state: ["0", Validators.required],
      district: ["0", Validators.required],
    });
    this.getStateList();
    localStorage.removeItem('localBreadCrumb');
    this.breadcrumbdata = [];
    var breadcrumbList1 = {
      label: 'Dealer Outlet Locator',
      url: `/find-dealer/`
    };
    this.breadcrumbdata.push(breadcrumbList1);
    this.localStorage.setItem('localBreadCrumb', JSON.stringify(this.breadcrumbdata));
    this.showBreadCrumb = true;
  }
  }


  lat: number = 51.673858;
  lng: number = 7.815982;
  close() {
    this.maker = true;
    this.openAgmWindow = false;

  }

  isInfoWindowOpen(id: any) {
    return this.openedWindow == id;
  }
  clickedMarker(infowindow: any) {
    if (this.previous) {
      this.previous.close();
    }
    this.previous = infowindow;
  }

  markers: marker[] = [
    {
      lat: 51.673858,
      lng: 7.815982,
      label: "A",
      draggable: true,
      content: "InfoWindow content",
      color: "#FFFFFF",
      iconUrl: "http://maps.google.com/mapfiles/ms/micons/gas.png"
    },
    {
      lat: 51.373858,
      lng: 7.215982,
      label: "B",
      draggable: false,
      content: "InfoWindow content",
      color: "blue",
      iconUrl: "http://maps.google.com/mapfiles/ms/micons/dollar.png"
    },
    {
      lat: 51.723858,
      lng: 7.495982,
      label: "C",
      draggable: true,
      content: "InfoWindow content",
      color: "red",
      iconUrl: "http://maps.google.com/mapfiles/ms/micons/police.png"
    }
  ];





  getStateList() {
    let data = {
      'action_type': "state",
      'dealer_code':this.dealerCode ?this.dealerCode:""
    };

    this.sub.add(this.apiService.findDealers(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.stateList = response["data"];
          if(this.dealerCode && this.stateList?.length > 0){
            this.dealerLocaterForm.patchValue({
              state: this.stateList[0].name+","+this.stateList[0].code,
            });
            this.getCity();
            return

          }
        }
        else{
        if(this.dealerCode){
          this.dealerCode="";
          this.getStateList();
        }
      }
      },
      error: (error) => {

      },
      complete: () => {
      }
    })
    );
  }

  getCity() {
    this.dealerLocaterForm.patchValue({
      district: "0",
      lob: "",
    });
    let state = this.dealerLocaterForm.value.state;
    let statedata = state.split(",");
    let ll = {};
    ll = {
      code: statedata[1],
      state: statedata[0],
    };
    let data = {
      'action_type': 'district',
      'state': ll,
      dealer_code:this.dealerCode ?this.dealerCode:""

    };

    this.sub.add(this.apiService.findDealers(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.districtList = response["data"];
          if(this.dealerCode && this.districtList?.length == 1){
            this.dealerLocaterForm.patchValue({
              district: this.districtList[0],
            });
            this.findDealerChange();
            this.findDealerData();
            return
          }
          if(this.dealerCode && this.districtList?.length > 1){
            this.dealerLocaterForm.patchValue({
              district: "0",
            });
            return
          }
        }
      },
      error: () => {

      },
      complete: () => {
      }
    })
    );
  }

  getLob() {
    this.dataloaded = false;
    this.countDisplay = 0;
    this.divisions = [];
    this.count = "";
    this.dealerLocaterForm.patchValue({
      lob: "",
    });
    let state = this.dealerLocaterForm.value.state;
    let statedata = state.split(",");
    let ll = {};
    ll = {
      code: statedata[1],
      state: statedata[0],
    };
    let district = this.dealerLocaterForm.value.district;
    let data = {
      'action_type': 'lob',
      'state': ll,
      "city": district
    };

    this.sub.add(this.apiService.findDealers(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.lobList = response["data"];
        }
      },
      error: () => {

      },
      complete: () => {
      }
    })
    );
  }

  findDealerChange() {
    this.hideSearch = false
  }

  findDealerData() {
    this.countDisplay = 0;
    this.divisions = [];
    let state = this.dealerLocaterForm.value.state;
    let statedata = state.split(",");

    let data = {
      state: {
        "code": statedata[1],
        "state": statedata[0]
      },
      "offset": 0,
      "size": 100,
      "district": this.dealerLocaterForm.value.district,
      'dealer_code':this.dealerCode ? this.dealerCode : ""

    };


    this.sub.add(this.apiService.findDealers(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.hideSearch = false
          this.isShowLocationSearch = true
          this.division = response["data"];
          this.dataloaded = true;
          this.flag = false;
          this.Lat = response["data"][0].latitude;
          this.Lng = response["data"][0].longitude;
          this.centerLat = Number(this.Lat);
          this.centerLng = Number(this.Lng);
          this.zoom = 8;
          this.maker = true;
          response["data"].forEach((res: any) => {
            this.divisions.push(res);
            if (res.latitude && res.longitude) {
              this.latLongList.push({ lat: res.latitude, long: res.longitude });
            }
          });
          this.countDisplay = this.divisions?.length;
          this.clickDisable = false;
        } else {
          this.flag = true;
          this.centerLat = 23.473324;
          this.centerLng = 77.947998;
          this.zoom = 4;
          this.maker = true;
          this.dataloaded = true;

        }
      },
      error: () => {

      },
      complete: () => {
      }
    })
    );
  }

  public mapReady(map: any) {
    map.addListener("dragend", () => {
    });
  }
  openWindow(id: any) {
    this.openedWindow = id;
    this.zoom = 14;
  }
  getNumber(number: any) {
    return 'tel:' + number
  }
  backToSearch() {
    this.dealerLocaterForm.reset()
    if (this.dealerLocaterForm.invalid)
      this.hideSearch = true
    this.isShowLocationSearch = false
    this.centerLat = 23.473324;
    this.centerLng = 77.947998;
    this.division = [];
    this.dealerLocaterForm.patchValue({
      district: "0",
      lob: "",
      state: "0",
    });
    this.districtList = [];
    this.divisions = [];
    this.Lat = 0;
    this.Lng = 0;
    this.zoom = 4;
  }

  getDirection(id: any, lat: any, lng: any) {
    this.maker = false;
    this.Lat = this.divisions[0].latitude;
    this.Lng = this.divisions[0].longitude;
    this.centerLat = Number(this.Lat);
    this.centerLng = Number(this.Lng);
    this.setDirection(id, lat, lng);
  }
  setDirection(id: any, lat: any, lng: any) {
    this.centerLat = Number(lat);
    this.centerLng = Number(lng);
    this.maker = true;
    this.openWindow(id);
  }
  seo() {
    this.seoservice.updateTitle(this.metatitle);
    this.seoservice.updateMetaTag("description", null, this.metadesc);
    this.seoservice.updateMetaTag(null, "og:locale", "en_US");
    this.seoservice.updateMetaTag(null, "og:type", "Website");
    this.seoservice.updateMetaTag(
      null,
      "og:title",
      this.metatitle
    );
    this.seoservice.updateMetaTag(null, "og:description", this.metadesc);
    this.seoservice.updateMetaTag(null, "og:url", environment.baseUrl + this.router.url);
    this.seoservice.updateMetaTag(null, "og:site_name", "Tata OSP");
  }

}

interface marker {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
  content: string;
  color: string;
  iconUrl: string;
}
